import Tr from 'translations/Translations';

export const AgreementState = {
    NEW: "NEW",
    ACCEPTING: "ACCEPTING",
    REGISTERED: "REGISTERED",
    FINISHED: "FINISHED",
    ANNULED: "ANNULED",
    CANCELED: "CANCELED",
    EXTERNALLY_REGISTERED: "EXTERNALLY_REGISTERED"
}
const _TR_PREFIX = 'agreement_state_';

export const AgreementStateLabel = (state) => (Tr(_TR_PREFIX + state.toLowerCase()));
